var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-page',[_c('com-search',{attrs:{"columns":_vm.searchColumns}}),_c('com-card',[_c('com-finance-list',{attrs:{"defaultParams":_vm.defaultParams}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }